import { useState, useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { ArrowRight, Search, X, ChevronDown, CheckCircle, Loader } from 'lucide-react';
import { publicAPI } from '../lib/api';
import axios from 'axios';

const AMOUNTS = [100000,150000,200000,250000,300000,350000,400000,450000,500000];

function SponsorModal({ topic, onClose }) {
  const [step, setStep] = useState(1); // 1=amount, 2=details, 3=success
  const [amount, setAmount] = useState('');
  const [form, setForm] = useState({ first_name:'', last_name:'', email:'', phone:'', profession:'', password:'' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [result, setResult] = useState(null);
  const [showPass, setShowPass] = useState(false);

  const handlePledge = async () => {
    setLoading(true);
    setError('');
    try {
      const res = await axios.post('/api/public/pledge', {
        ...form,
        topic_id: topic.id,
        amount: parseFloat(amount),
      });
      setResult(res.data);
      setStep(3);
    } catch (err) {
      setError(err.response?.data?.error || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.8)', zIndex:1000, display:'flex', alignItems:'center', justifyContent:'center', padding:16 }} onClick={e => e.target===e.currentTarget && onClose()}>
      <div style={{ background:'#0d1117', border:'1px solid rgba(201,162,39,0.2)', borderRadius:16, padding:32, width:'100%', maxWidth:480, maxHeight:'90vh', overflowY:'auto' }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
          <h2 style={{ fontFamily:'var(--font-display)', fontSize:'1.4rem', fontWeight:500, color:'var(--gold)' }}>
            {step===3 ? 'Pledge Confirmed' : 'Sponsor This Topic'}
          </h2>
          <button onClick={onClose} style={{ background:'none', border:'none', cursor:'pointer', color:'var(--text-muted)', padding:4 }}><X size={20} /></button>
        </div>

        {step < 3 && (
          <div style={{ marginBottom:20, padding:'12px 16px', background:'rgba(201,162,39,0.05)', borderRadius:10, border:'1px solid rgba(201,162,39,0.15)' }}>
            <div style={{ fontSize:'0.75rem', color:'var(--text-muted)', fontFamily:'var(--font-mono)', letterSpacing:'0.1em', marginBottom:4 }}>SELECTED TOPIC</div>
            <div style={{ fontSize:'0.9rem', color:'var(--text-primary)', fontWeight:500 }}>{topic.title}</div>
            {topic.department && <div style={{ fontSize:'0.75rem', color:'var(--text-muted)', marginTop:4 }}>{topic.department}</div>}
          </div>
        )}

        {step === 1 && (
          <div>
            <p style={{ fontSize:'0.875rem', color:'var(--text-secondary)', marginBottom:20, lineHeight:1.6 }}>
              Select your sponsorship amount. Alumni sponsors are recognised in the Hall of Honour and receive a named sponsor certificate.
            </p>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(3,1fr)', gap:10, marginBottom:24 }}>
              {AMOUNTS.map(a => (
                <button key={a} onClick={() => setAmount(String(a))} style={{ padding:'12px 8px', borderRadius:10, border:`1px solid ${amount===String(a) ? 'var(--gold)' : 'rgba(255,255,255,0.08)'}`, background:amount===String(a) ? 'rgba(201,162,39,0.1)' : 'rgba(255,255,255,0.02)', color:amount===String(a) ? 'var(--gold)' : 'var(--text-secondary)', cursor:'pointer', fontSize:'0.8rem', fontWeight:amount===String(a)?600:400, transition:'all 0.15s' }}>
                  ₦{(a/1000)}k
                </button>
              ))}
            </div>
            <button className="btn btn-primary" style={{ width:'100%', justifyContent:'center' }} disabled={!amount} onClick={() => setStep(2)}>
              Continue <ArrowRight size={16} />
            </button>
          </div>
        )}

        {step === 2 && (
          <div>
            <p style={{ fontSize:'0.875rem', color:'var(--text-secondary)', marginBottom:20, lineHeight:1.6 }}>
              Your details will be used to create your sponsor account on Futurum.
            </p>
            {error && <div style={{ padding:'12px 14px', background:'rgba(239,68,68,0.1)', border:'1px solid rgba(239,68,68,0.2)', borderRadius:8, fontSize:'0.85rem', color:'#ef4444', marginBottom:16 }}>{error}</div>}
            <div style={{ display:'flex', flexDirection:'column', gap:12, marginBottom:20 }}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:12 }}>
                {[['first_name','First Name'],['last_name','Last Name']].map(([k,l]) => (
                  <div key={k}>
                    <label style={{ fontSize:'0.75rem', color:'var(--text-muted)', display:'block', marginBottom:6, letterSpacing:'0.05em' }}>{l.toUpperCase()} *</label>
                    <input value={form[k]} onChange={e => setForm(f=>({...f,[k]:e.target.value}))} style={{ width:'100%', background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:8, padding:'10px 12px', color:'var(--text-primary)', fontSize:'0.875rem' }} />
                  </div>
                ))}
              </div>
              {[['email','Email Address','email'],['phone','Phone Number','tel'],['profession','Profession / Company','text']].map(([k,l,t]) => (
                <div key={k}>
                  <label style={{ fontSize:'0.75rem', color:'var(--text-muted)', display:'block', marginBottom:6, letterSpacing:'0.05em' }}>{l.toUpperCase()}{k!=='phone'?' *':''}</label>
                  <input type={t} value={form[k]} onChange={e => setForm(f=>({...f,[k]:e.target.value}))} style={{ width:'100%', background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:8, padding:'10px 12px', color:'var(--text-primary)', fontSize:'0.875rem' }} />
                </div>
              ))}
              <div>
                <label style={{ fontSize:'0.75rem', color:'var(--text-muted)', display:'block', marginBottom:6, letterSpacing:'0.05em' }}>PASSWORD *</label>
                <div style={{ position:'relative' }}>
                  <input type={showPass?'text':'password'} value={form.password} onChange={e => setForm(f=>({...f,password:e.target.value}))} style={{ width:'100%', background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.1)', borderRadius:8, padding:'10px 40px 10px 12px', color:'var(--text-primary)', fontSize:'0.875rem' }} />
                  <button type="button" onClick={() => setShowPass(s=>!s)} style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'var(--text-muted)', fontSize:'0.75rem' }}>{showPass?'Hide':'Show'}</button>
                </div>
              </div>
            </div>
            <div style={{ display:'flex', gap:10 }}>
              <button className="btn btn-ghost" onClick={() => setStep(1)} style={{ flex:1, justifyContent:'center' }}>Back</button>
              <button className="btn btn-primary" style={{ flex:2, justifyContent:'center' }} disabled={loading || !form.first_name || !form.last_name || !form.email || !form.password} onClick={handlePledge}>
                {loading ? <><Loader size={14} style={{ animation:'spin 1s linear infinite' }} /> Processing…</> : <>Confirm Pledge of ₦{Number(amount).toLocaleString()} <ArrowRight size={14} /></>}
              </button>
            </div>
          </div>
        )}

        {step === 3 && result && (
          <div style={{ textAlign:'center' }}>
            <div style={{ width:64, height:64, borderRadius:'50%', background:'rgba(42,157,143,0.15)', border:'2px solid var(--teal)', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 20px' }}>
              <CheckCircle size={28} style={{ color:'var(--teal)' }} />
            </div>
            <p style={{ fontSize:'0.9rem', color:'var(--text-secondary)', marginBottom:24, lineHeight:1.7 }}>
              Your account has been created and your pledge of <strong style={{ color:'var(--gold)' }}>₦{Number(result.amount).toLocaleString()}</strong> for <strong style={{ color:'var(--text-primary)' }}>{result.topic_title}</strong> has been recorded.
            </p>
            <div style={{ background:'rgba(201,162,39,0.06)', border:'1px solid rgba(201,162,39,0.2)', borderRadius:12, padding:20, marginBottom:24, textAlign:'left' }}>
              <div style={{ fontSize:'0.75rem', color:'var(--text-muted)', fontFamily:'var(--font-mono)', letterSpacing:'0.1em', marginBottom:12 }}>TRANSFER DETAILS</div>
              {[['Bank', result.bank?.bank_name], ['Account Name', result.bank?.account_name], ['Account Number', result.bank?.account_number], ['Amount', '₦'+Number(result.amount).toLocaleString()], ['Reference / Narration', result.reference]].map(([l,v]) => (
                <div key={l} style={{ display:'flex', justifyContent:'space-between', alignItems:'center', padding:'8px 0', borderBottom:'1px solid rgba(255,255,255,0.05)' }}>
                  <span style={{ fontSize:'0.8rem', color:'var(--text-muted)' }}>{l}</span>
                  <span style={{ fontSize:'0.875rem', color: l==='Reference / Narration' ? 'var(--gold)' : 'var(--text-primary)', fontWeight: l==='Reference / Narration'?700:400, fontFamily: l==='Account Number'||l==='Reference / Narration'?'var(--font-mono)':'inherit' }}>{v}</span>
                </div>
              ))}
            </div>
            <p style={{ fontSize:'0.8rem', color:'var(--text-muted)', marginBottom:20, lineHeight:1.6 }}>
              Please use your reference code as the transfer narration. A confirmation email has been sent to you. After your transfer, upload your receipt on the platform.
            </p>
            <div style={{ display:'flex', gap:10, justifyContent:'center' }}>
              <Link to="/login" className="btn btn-primary" onClick={onClose}>Sign In to Your Account <ArrowRight size={14} /></Link>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default function PublicTopicsPage() {
  const [searchParams] = useSearchParams();
  const season = searchParams.get('season') || '';
  const [topics, setTopics] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [domain, setDomain] = useState('');
  const [domains, setDomains] = useState([]);
  const [filter, setFilter] = useState('all');
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [selectedTopic, setSelectedTopic] = useState(null);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    publicAPI.getDomains().then(r => setDomains(r.data.domains || [])).catch(() => {});
  }, []);

  useEffect(() => {
    setLoading(true);
    const params = { page, limit:12 };
    if (search) params.search = search;
    if (domain) params.domain = domain;
    if (season) params.season = season;
    if (filter === 'open') params.is_sponsored = false;
    if (filter === 'sponsored') params.is_sponsored = true;
    publicAPI.getTopics(params)
      .then(r => { setTopics(r.data.topics||[]); setTotal(r.data.pagination?.total||0); setPages(r.data.pagination?.pages||1); })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [search, domain, filter, page, season]);

  return (
    <div style={{ background:'var(--surface-body)', color:'var(--text-primary)', minHeight:'100vh' }}>
      {/* Nav */}
      <nav className={`public-nav${scrolled?' scrolled':''}`} style={{ justifyContent:'space-between' }}>
        <Link to="/" style={{ fontFamily:'var(--font-display)', fontSize:'1.2rem', color:'var(--gold)', fontWeight:600, textDecoration:'none' }}>
          Futurum Innovation Awards
        </Link>
        <div style={{ display:'flex', alignItems:'center', gap:20 }}>
          <Link to="/" style={{ fontSize:'0.875rem', color:'var(--text-secondary)', textDecoration:'none' }}>Home</Link>
          <Link to="/honour" style={{ fontSize:'0.875rem', color:'var(--text-secondary)', textDecoration:'none' }}>Hall of Honour</Link>
          <Link to="/login" style={{ fontSize:'0.875rem', color:'var(--text-secondary)', textDecoration:'none' }}>Sign In</Link>
          <Link to="/register?role=alumni" className="btn btn-primary btn-sm">Become a Sponsor</Link>
        </div>
      </nav>

      {/* Header */}
      <div style={{ paddingTop:120, paddingBottom:60, borderBottom:'1px solid rgba(255,255,255,0.05)' }}>
        <div className="container">
          <div className="eyebrow" style={{ marginBottom:16 }}>Season II · Open for Sponsorship</div>
          <h1 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(2.5rem,5vw,4rem)', fontWeight:400, marginBottom:16, lineHeight:1.1 }}>
            {total} Research Topics<br /><span style={{ color:'var(--gold)', fontStyle:'italic' }}>waiting for sponsors.</span>
          </h1>
          <p style={{ color:'var(--text-secondary)', maxWidth:560, lineHeight:1.7, marginBottom:32 }}>
            Each topic is proposed by an OAU engineering faculty or researcher. Your sponsorship funds one final-year student's research and puts your name on the project permanently.
          </p>
          <div style={{ display:'flex', gap:32 }}>
            {[['₦100k–₦500k','Sponsorship Range'],['Named','Your recognition'],['Hall of Honour','Permanent record']].map(([v,l]) => (
              <div key={l}>
                <div style={{ fontFamily:'var(--font-display)', fontSize:'1.5rem', color:'var(--gold)', fontWeight:600 }}>{v}</div>
                <div style={{ fontSize:'0.72rem', color:'var(--text-muted)', textTransform:'uppercase', letterSpacing:'0.08em', fontFamily:'var(--font-mono)', marginTop:4 }}>{l}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Filters */}
      <div style={{ borderBottom:'1px solid rgba(255,255,255,0.05)', padding:'20px 0', position:'sticky', top:0, background:'rgba(13,17,23,0.95)', backdropFilter:'blur(12px)', zIndex:10 }}>
        <div className="container" style={{ display:'flex', gap:12, flexWrap:'wrap', alignItems:'center' }}>
          <div style={{ position:'relative', flex:'1', minWidth:200 }}>
            <Search size={14} style={{ position:'absolute', left:12, top:'50%', transform:'translateY(-50%)', color:'var(--text-muted)' }} />
            <input value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} placeholder="Search topics..." style={{ width:'100%', paddingLeft:36, paddingRight:12, paddingTop:10, paddingBottom:10, background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:8, color:'var(--text-primary)', fontSize:'0.875rem' }} />
          </div>
          <select value={domain} onChange={e => { setDomain(e.target.value); setPage(1); }} style={{ padding:'10px 12px', background:'rgba(255,255,255,0.03)', border:'1px solid rgba(255,255,255,0.08)', borderRadius:8, color:'var(--text-secondary)', fontSize:'0.875rem' }}>
            <option value="">All Domains</option>
            {domains.map(d => <option key={d} value={d}>{d}</option>)}
          </select>
          {['all','open','sponsored'].map(f => (
            <button key={f} onClick={() => { setFilter(f); setPage(1); }} style={{ padding:'10px 16px', borderRadius:8, border:`1px solid ${filter===f?'var(--gold)':'rgba(255,255,255,0.08)'}`, background:filter===f?'rgba(201,162,39,0.1)':'transparent', color:filter===f?'var(--gold)':'var(--text-muted)', fontSize:'0.8rem', cursor:'pointer', textTransform:'capitalize' }}>{f==='all'?'All Topics':f==='open'?'Open':'Sponsored'}</button>
          ))}
        </div>
      </div>

      {/* Topics Grid */}
      <div className="container" style={{ padding:'48px 0 80px' }}>
        {loading ? (
          <div style={{ textAlign:'center', padding:'80px 0', color:'var(--text-muted)' }}><Loader size={24} style={{ animation:'spin 1s linear infinite' }} /></div>
        ) : topics.length === 0 ? (
          <div style={{ textAlign:'center', padding:'80px 0', color:'var(--text-muted)' }}>No topics found.</div>
        ) : (
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(340px,1fr))', gap:24 }}>
            {topics.map(topic => (
              <div key={topic.id} className="card" style={{ padding:28, display:'flex', flexDirection:'column', gap:16, position:'relative', transition:'transform 0.15s, box-shadow 0.15s' }}
                onMouseEnter={e => { e.currentTarget.style.transform='translateY(-2px)'; e.currentTarget.style.boxShadow='0 8px 32px rgba(201,162,39,0.08)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform=''; e.currentTarget.style.boxShadow=''; }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', gap:12 }}>
                  <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
                    <span style={{ fontSize:'0.65rem', fontFamily:'var(--font-mono)', letterSpacing:'0.12em', padding:'3px 10px', borderRadius:999, background: topic.is_sponsored?'rgba(42,157,143,0.1)':'rgba(201,162,39,0.08)', color:topic.is_sponsored?'var(--teal)':'var(--gold)', border:`1px solid ${topic.is_sponsored?'rgba(42,157,143,0.2)':'rgba(201,162,39,0.2)'}` }}>
                      {topic.is_sponsored ? '● SPONSORED' : '● OPEN'}
                    </span>
                    {topic.domain && <span style={{ fontSize:'0.65rem', fontFamily:'var(--font-mono)', letterSpacing:'0.1em', padding:'3px 10px', borderRadius:999, background:'rgba(255,255,255,0.04)', color:'var(--text-muted)', border:'1px solid rgba(255,255,255,0.06)' }}>{topic.domain}</span>}
                  </div>
                </div>
                <h3 style={{ fontFamily:'var(--font-display)', fontSize:'1.05rem', fontWeight:500, lineHeight:1.4, color:'var(--text-primary)', margin:0 }}>{topic.title}</h3>
                {topic.description && <p style={{ fontSize:'0.825rem', color:'var(--text-secondary)', lineHeight:1.65, margin:0, display:'-webkit-box', WebkitLineClamp:3, WebkitBoxOrient:'vertical', overflow:'hidden' }}>{topic.description}</p>}
                <div style={{ marginTop:'auto', display:'flex', justifyContent:'space-between', alignItems:'center', paddingTop:16, borderTop:'1px solid rgba(255,255,255,0.05)' }}>
                  <div>
                    <div style={{ fontSize:'0.75rem', color:'var(--text-muted)' }}>{topic.lecturer_title ? topic.lecturer_title + ' ' : ''}{topic.lecturer_name}</div>
                    {topic.department && <div style={{ fontSize:'0.7rem', color:'var(--text-muted)', marginTop:2 }}>{topic.department}</div>}
                  </div>
                  {!topic.is_sponsored ? (
                    <button className="btn btn-primary btn-sm" onClick={() => setSelectedTopic(topic)}>
                      Sponsor This <ArrowRight size={13} />
                    </button>
                  ) : (
                    <span style={{ fontSize:'0.75rem', color:'var(--teal)', fontFamily:'var(--font-mono)' }}>Funded</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Pagination */}
        {pages > 1 && (
          <div style={{ display:'flex', justifyContent:'center', gap:8, marginTop:48 }}>
            <button onClick={() => setPage(p=>Math.max(1,p-1))} disabled={page===1} className="btn btn-ghost" style={{ fontSize:'0.85rem' }}>← Previous</button>
            <span style={{ padding:'10px 16px', fontSize:'0.85rem', color:'var(--text-muted)' }}>Page {page} of {pages}</span>
            <button onClick={() => setPage(p=>Math.min(pages,p+1))} disabled={page===pages} className="btn btn-ghost" style={{ fontSize:'0.85rem' }}>Next →</button>
          </div>
        )}

        {/* Bottom CTA */}
        <div style={{ marginTop:80, padding:48, borderRadius:20, background:'linear-gradient(135deg,rgba(201,162,39,0.06) 0%,rgba(42,157,143,0.04) 100%)', border:'1px solid rgba(201,162,39,0.12)', textAlign:'center' }}>
          <h2 style={{ fontFamily:'var(--font-display)', fontSize:'clamp(1.75rem,3vw,2.5rem)', fontWeight:400, marginBottom:16 }}>
            Already have an account?
          </h2>
          <p style={{ color:'var(--text-secondary)', maxWidth:420, margin:'0 auto 28px', lineHeight:1.7, fontSize:'0.9rem' }}>
            Sign in to manage your sponsorships, review applicants, and track your funded projects.
          </p>
          <Link to="/login" className="btn btn-primary btn-lg">Sign In <ArrowRight size={16} /></Link>
        </div>
      </div>

      {selectedTopic && <SponsorModal topic={selectedTopic} onClose={() => setSelectedTopic(null)} />}
    </div>
  );
}
